define((require) => {
    "use strict";

    const FontIntegrationModel = require("editor/ui/settings/integrations/FontIntegrationModel");

    /**
     * Typekit integration model.
     *
     * @class TypekitIntegrationModel
     */
    return FontIntegrationModel.extend("TypekitIntegration", {

        defaults: {
            typekitApiToken: null
        }
    }, {
        type: "TypekitIntegration"
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/TypekitIntegrationModel.js